import React, {useState, useEffect} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {
    Box,
    TextField,
    Typography,
    Button,
    Card,
    CardContent,
    Container,
    CircularProgress, FormHelperText,
} from "@mui/material";
import Api from "../../Services/Api";
import { Snackbar, Alert } from "@mui/material";


const Settings = () => {
    const [apiToken, setApiToken] = useState("");
    const [isApiTokenGenerated, setIsApiTokenGenerated] = useState(false);
    const [globalPostback, setGlobalPostback] = useState("");
    const [loading, setLoading] = useState(false);
    const [postbackLoading, setPostbackLoading] = useState(false);
    const [postbackError, setPostbackError] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);



    const handleGenerateApiToken = () => {

        setLoading(true)
        Api.userGenerateApiToken()
            .then(r => {
                if (r) {
                    setApiToken(r.api_token);
                    setIsApiTokenGenerated(true);
                }
            }).catch((error) => {
            console.error("Error fetching API token:", error);
        })
            .finally(() => {
                setLoading(false);
            });
        const newApiToken = "your_new_generated_api_token";
        setApiToken(newApiToken);
        setIsApiTokenGenerated(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };
    const handleSaveSettings = () => {
        setPostbackLoading(true);
        setPostbackError("");

        Api.userSavePostback({ global_postback: globalPostback })
            .then((response) => {
                console.log(response);
                if (response) {

                    setGlobalPostback(response.postback);
                    setSnackbarOpen(true);
                }
            })
            .catch((error) => {
                console.error("Error saving Global Postback:", error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setPostbackError(error.response.data.errors.global_postback[0]);
                } else {
                    setPostbackError("Error saving Global Postback. Please try again.");
                }
            })
            .finally(() => {
                setPostbackLoading(false);
            });
    };


    useEffect(() => {


        Api.userGetPostback()
            .then((r) => {
                if (r) {
                    setGlobalPostback(r.postback);
                }
            })
            .catch((error) => {
                console.error("Error fetching postback :", error);
            });
    }, []);

    return (
        <MainLayout>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
                    Global Postback saved successfully!
                </Alert>
            </Snackbar>
            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Box sx={{mt: 3, mb: 3}}>
                    <Typography variant="h4">User Settings</Typography>
                </Box>
                <Card sx={{ mb: 4 }}>
                    <CardContent>
                        <Typography variant="h6">API Token</Typography>
                        {loading ? (
                            <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
                                <CircularProgress />
                            </Box>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    label="API Token"
                                    value={apiToken}
                                    margin="normal"
                                    variant="outlined"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    disabled={!isApiTokenGenerated}
                                />
                                {isApiTokenGenerated && (
                                    <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                                        Warning: Please copy the bearer token before refreshing the page. All the other tokens have been revoked.
                                    </Typography>
                                )}
                                {!isApiTokenGenerated && (
                                    <Box sx={{ mt: 1 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handleGenerateApiToken}
                                        >
                                            Generate API Token
                                        </Button>
                                    </Box>
                                )}
                                {isApiTokenGenerated && (
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                        This API token is used to get stats from the API.{" "}
                                        <a
                                            href="https://drive.google.com/file/d/1h3FrxwZRuUZX2IL5nq0d8yM7vviZ0KD5/view?usp=sharing"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Learn more in our documentation.
                                        </a>
                                    </Typography>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>


                <Card>
                    <CardContent>
                        <Typography variant="h6">Global Postback</Typography>
                        <TextField
                            fullWidth
                            label="Global Postback URL"
                            value={globalPostback}
                            onChange={(e) => setGlobalPostback(e.target.value)}
                            margin="normal"
                            variant="outlined"
                            error={!!postbackError}
                        />
                        {postbackError && (
                            <FormHelperText error>{postbackError}</FormHelperText>
                        )}
                        <Typography variant="body2" sx={{mt: 1}}>
                            This is the postback URL to use when firing clicks on ads. Remember
                            to send the click_id to us first.
                        </Typography>
                        <Typography variant="body2" sx={{mt: 1, fontStyle: "italic"}}>
                            Remark: Postback only works with a few N2S feeds, ask your account
                            manager for more details. The only macro available is{" "}
                            <code>{'{click_id}'}</code>.
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSaveSettings}
                                disabled={postbackLoading}
                            >
                                {postbackLoading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    "Save Settings"
                                )}
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </MainLayout>
    );
};

export default Settings;
